import axios from "axios";
import {SERVER_API_URL} from "./constants";
import store from "@/store";

const http = axios.create({
  baseURL: SERVER_API_URL + "api/",
  headers: {
    "Content-type": "application/json"
  }
});

http.interceptors.request.use(function (config: any) {
  const token = localStorage.getItem('authenticationToken') || sessionStorage.getItem('authenticationToken') || store.getters.getAuthenticationToken;
  if (token) {
    config.headers.Authorization = "Bearer " + token;
  }
  return config;
});

export default http;
